export default "__VITE_ASSET__0UQObmxo__"